import React from 'react';
import { MemoryRouter } from 'react-router-dom';
import { WizardProvider } from './components/WizardProvider';
import { toStepProvider } from './components/StepProvider';

export type StepWizardProps = {
  children: React.ReactNode;
};

const StepWizard = ({ children }: StepWizardProps): JSX.Element => {
  const steps = React.Children.toArray(children);

  const stepEntries = React.Children.map(steps, (child, i) => `step${i + 1}`);

  const childrenStep = React.Children.map(steps, toStepProvider);

  return (
    <MemoryRouter initialEntries={stepEntries} initialIndex={0}>
      <WizardProvider>{childrenStep}</WizardProvider>
    </MemoryRouter>
  );
};

export { StepWizard };
